@for (item of userOtherFirstNames.controls; track item; let i = $index) {
  <div class="row-flex">
    <pr-input-column
      label="Prénom(s) d’état civil"
      [derrors]="derrors"
      [required]="isRequired && i === 0"
      style="width: 100%"
    >
      <input
        placeholder="Jean"
        [formControl]="userOtherFirstNames.controls[i]"
        [name]="'userOtherFirstNames' + i"
        type="text"
      />
    </pr-input-column>
    @if (userOtherFirstNames.length > 1) {
      <pr-button-confirm
        class="confirm"
        display="danger"
        clazz="pr-toolbar-button last"
        icon="delete_outline"
        title="Suppression"
        comment="Toute suppression est définitve, les données seront perdues."
        labelConfirm="Supprimer"
        labelCancel="Annuler"
        (onConfirm)="deleteFields(i)"
      >
        Êtes-vous sûr(e) de vouloir supprimer
        @if (userOtherFirstNames?.controls?.[i]?.value) {
          <em>“{{ userOtherFirstNames.controls[i].value }}”</em>
        }
      </pr-button-confirm>
    }
  </div>
}

@if (derrors && isRequired && userOtherFirstNames.errors?.required) {
  <ul class="first-names-error">
    <li>ce champs est requis</li>
  </ul>
}

<pr-button-add
  type="button"
  display="neutral"
  (click)="addFields()"
  label="Ajouter un prénom"
  rightIcon="+"
>
</pr-button-add>
